import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
const Footer = () => {
  return (
    <footer className="sticky-footer">
      <div className="footer-content">
        <Link to={'/account-statement'} className="footer-icon">
          {/* <FontAwesomeIcon icon={faHistory} size="1x" title="history" /> */}
          <img className='images-icon-footer' src="home/images/notes.png" alt="Home" />
          <span>History</span>
        </Link>
        <Link to={'/all-bid'}  className="footer-icon">
          {/* <FontAwesomeIcon icon={faGavel} size="1x" title="Bids" /> */}
          <img className='images-icon-footer' src="home/images/auction.png" alt="Home" />
          <span>All Bids</span>
        </Link>
       
        <Link  to={'/home'} className="footer-icon">
          {/* <FontAwesomeIcon icon={faHouse} size="1x" title="home" /> */}
          <img className='images-icon-footer' src="home/images/home.png" alt="Home" />
          <span>Home</span>
        </Link>
        <Link  to={'/wallet_histroy'} className="footer-icon">
          {/* <FontAwesomeIcon icon={faWallet} size="1x" title="Withdraw" /> */}
          <img className='images-icon-footer' src="home/images/wallet.png" alt="Home" />
          <span>wallet</span>
        </Link>
        <Link  to={'https://matkafun.us?type=URL_FOR_WEBSITE'} target='_blank' className="footer-icon">
          {/* <FontAwesomeIcon icon={faGlobe} size="1x" title="Website" /> */}
          <img className='images-icon-footer' src="home/images/website.png" alt="Home" />
          <span>Website</span>
        </Link>
        
        
      </div>
    </footer>
  );
};

export default Footer;
